import { type AuditText, auditMessage } from '../text';

/** Summaries cut long strings here so the line keeps room for the next field. */
export const SUMMARY_VALUE_LENGTH = 40;

/** The first two texts, then how many more there are. */
export function firstTwo(texts: readonly AuditText[]): AuditText | null {
    const [first, second] = texts;
    if (first === undefined) return null;
    if (second === undefined) return first;
    const more = texts.length - 2;
    return more > 0
        ? auditMessage('auditLog.summary.twoMore', { first, second, more })
        : auditMessage('auditLog.summary.two', { first, second });
}

export function textField(record: Record<string, unknown>, field: string): string | null {
    const value = record[field];
    return typeof value === 'string' && value.trim() !== '' ? value : null;
}

export function numberField(record: Record<string, unknown>, field: string): number | null {
    const value = record[field];
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function listLength(record: Record<string, unknown>, field: string): number | null {
    const value = record[field];
    return Array.isArray(value) ? value.length : null;
}
